var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifyBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.3c-2.87 0-5.2 2.28-5.2 5.1v2.5c0 1.53-.5 3.02-1.42 4.25-.31.41-.01.99.51.99h12.22c.52 0 .82-.58.51-.99a7.06 7.06 0 0 1-1.42-4.25V9.4c0-2.82-2.33-5.1-5.2-5.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.3V2.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 19.3a1.85 1.85 0 0 0 3.4 0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyBell);
export default __webpack_public_path__ + "static/media/notify-bell.e9ea3711b168f4ed3a705ba9f822ccd0.svg";
export { ForwardRef as ReactComponent };